import { render } from "./CustomFieldsModal.vue?vue&type=template&id=245a5038&scoped=true"
import script from "./CustomFieldsModal.vue?vue&type=script&lang=js"
export * from "./CustomFieldsModal.vue?vue&type=script&lang=js"

import "./CustomFieldsModal.vue?vue&type=style&index=0&id=245a5038&lang=scss&scoped=true"
import "./CustomFieldsModal.vue?vue&type=style&index=1&id=245a5038&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-245a5038"]])

export default __exports__